import { SheLocation } from '../../mainv3/types/location';
import { ISODateTime } from '../../admin/types/date';

export type TrialLessonId = number;
export enum TrialLessonStatus {
    ACTIVE = 'active',
    HIDDEN = 'hidden',
    FULL = 'full',
}
export enum TrialLessonTarget {
    NORMAL = 'normal',
    EXPERT = 'expert',
}

export type TrialLessonArea = 'tokyo' | 'nagoya';

export type TrialLessonIndexView = {
    id: TrialLessonId;
    title: string;
    lesson1: string;
    lesson2: string;
    capacity: number;
    location?: SheLocation;
    active_reservation_count: number;
    status: TrialLessonStatus;
    starts_at: ISODateTime;
    ends_at: ISODateTime;
    created_at: ISODateTime;
};

export type EditableTrialLesson = TrialLessonIndexView;
